module.exports = __webpack_public_path__ + "img/shizhong.ee0c9f76.png";